<template>
  <div class="login-player customer-common">
    <LoginHead title="选手端" top="50" />
    <div class="login-handle cus-style">
      <div class="input">
        <van-field
          class="inputPhone"
          v-model="phone"
          center
          clearable
          :error="validate.reg_verify_err.phone"
          placeholder="手机号码"
          maxlength="11"
          @change="gettel('phone')"
        >
          <template #button>
            <van-popover
              v-model="showPopover"
              trigger="click"
              :actions="actions"
              @select="onSelect"
            >
              <template #reference>
                <div class="overallbaseline arrowBox">
                  <div>{{ actionsValue }}</div>
                  <img
                    class="arrow"
                    :style="showPopover ? '' : 'transform:rotate(-90deg)'"
                    :src="require('../../assets/images/arrow.png')"
                    alt=""
                  />
                </div>
              </template>
            </van-popover>
          </template>
        </van-field>
        <van-field
          v-model="pwd"
          :type="!switchValues ? 'password' : 'text'"
          center
          clearable
          :error="validate.reg_verify_err.pwd"
          @change="validate.pwd('pwd')"
          placeholder="登录密码"
        >
          <template #button>
            <img
              :src="
                require(`../../assets/images/login/${
                  switchValues ? '' : 'un'
                }view-ico.png`)
              "
              @click="switchValues = !switchValues"
            />
          </template>
        </van-field>
      </div>
      <div class="other">
        <div class="user-handle">
          <div @click="$router.push('/register')">注册选手</div>
          <!-- <div @click="$root.mipLink('/orgregister')">注册报名服务单位</div> -->
          <div @click="$router.push('/pwdretrieve')">忘记密码</div>
        </div>
        <div class="login-btn">
          <van-button
            size="large"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            :loading="loading"
            @click="fnLogin"
            >登录</van-button
          >
        </div>

        <div class="agreement">
          <van-checkbox v-model="agree" @click="handleAgreementClick('user')">
            <template #icon="props">
              <img
                class="img-icon"
                :src="
                  props.checked
                    ? require('../../assets/images/login/checked-ico.png')
                    : require('../../assets/images/login/unchecked-ico.png')
                "
              />
            </template>
          </van-checkbox>
          已阅读并同意<span @click.stop="openAgreement('user')"> 《用户协议》</span>
        </div>
        <div class="agreement" style="margin-top: 8px;">
          <van-checkbox v-model="agree2" @click="handleAgreementClick('privacy')">
            <template #icon="props">
              <img
                class="img-icon"
                :src="
                  props.checked
                    ? require('../../assets/images/login/checked-ico.png')
                    : require('../../assets/images/login/unchecked-ico.png')
                "
              />
            </template>
          </van-checkbox>
          已阅读并同意<span @click.stop="openAgreement('privacy')"> 《隐私协议》</span>
        </div>
        <div class="wx-login" v-if="port != 'douyin'">
          <p>其他登录方式（仅限选手用户）</p>
          <div class="wx-logo" @click="targetPage"></div>
        </div>
      </div>
    </div>
    
    <!-- 协议弹窗 -->
    <AgreementPopup
      v-model="agreementPopup"
      :title="getCurrentAgreementTitle()"
      :content="getCurrentAgreementContent()"
      :read-time="5"
      @confirm="onAgreementConfirm"
    />
  </div>
</template>

<script>
import { login } from "../../utils/api/user";
import { validate } from "@/utils/mixin/validate";
import LoginHead from "@/components/login/HeadWrap.vue";
import { wxlogin } from "@/utils/mixin/wxlogin";
import { getUserAgreement, getArticleDetails } from "../../utils/api/user";
import AgreementPopup from "@/components/pub/AgreementPopup.vue";
// import PwdSwitch from "@/components/login/PwdSwitch.vue";
import { mapActions } from "vuex";
export default {
  mixins: [validate, wxlogin],
  components: {
    LoginHead,
    AgreementPopup
    // ["password-switch"]: PwdSwitch
  },
  data() {
    return {
      phone: "",
      pwd: "",
      agreement: '',
      privacy: '',
      // 协议弹窗相关
      agreementPopup: false,
      currentAgreementType: '',
      agree: false,
      agree2: false,
      switchValues: false,
      loading: false,
      showPopover: false,
      actions: [
        {
          text: "中国内地+86",
          value: 86
        },
        {
          text: "中国香港+852",
          value: 852
        },
        {
          text: "中国澳门+853",
          value: 852
        }
      ],
      actionsValue: "中国内地+86",
      port: localStorage.getItem("port")
    };
  },
  mounted() {
    // eslint-disable-next-line
    this.verification = new Verification.Init();
    getUserAgreement().then((res) => {
      if (res.success) {
        this.agreement = res.data.contents;
      }
    });
    getArticleDetails(7).then((res) => {
      if (res.success) {
        this.privacy = res.data;
      }
    });
  },
  methods: {
    // 处理协议勾选点击
    handleAgreementClick(type) {
      console.log('处理协议勾选点击', type, this.agree);
      if (type === 'user') {
        if (this.agree) {
          // 如果要勾选，先打开弹窗
          this.currentAgreementType = 'user';
          this.agree = false;
          this.agreementPopup = true;
        }
      } else if (type === 'privacy') {
        if (this.agree2) {
          // 如果要勾选，先打开弹窗
          this.currentAgreementType = 'privacy';
          this.agree2 = false;
          this.agreementPopup = true;
        }
      }
    },
    // 打开协议弹窗（点击协议文字）
    openAgreement(type) {
      this.currentAgreementType = type;
      this.agreementPopup = true;
    },
    // 协议确认回调
    onAgreementConfirm() {
      if (this.currentAgreementType === 'user') {
        this.agree = true;
      } else if (this.currentAgreementType === 'privacy') {
        this.agree2 = true;
      }
    },
    // 获取当前协议内容
    getCurrentAgreementContent() {
      if (this.currentAgreementType === 'user') {
        return this.agreement;
      } else if (this.currentAgreementType === 'privacy') {
        return this.privacy;
      }
      return '';
    },
    // 获取当前协议标题
    getCurrentAgreementTitle() {
      if (this.currentAgreementType === 'user') {
        return '用户协议';
      } else if (this.currentAgreementType === 'privacy') {
        return '隐私协议';
      }
      return '协议';
    },
    onSelect(action) {
      this.actionsValue = action.text;
      this.phone = "";
    },
    gettel(key) {
      let val = this[key];
      if (this.validate.formDataKey) {
        val = this[this.validate.formDataKey][key];
      }
      let res = "";
      if (
        this.actionsValue == "中国香港+852" ||
        this.actionsValue == "中国澳门+853"
      ) {
        res = val.length == 8;
      } else {
        res = val.length == 11;
      }
      if (!res) {
        this.validate.reg_verify_err_msg[key] = `请输入正确的手机号`;
        this.$toast.fail("请输入正确的手机号");
      } else {
        this.validate.reg_verify_err_msg[key] = "";
      }
      this.validate.reg_verify_err[key] = !res;
      this.$forceUpdate();
      return res;
    },
    ...mapActions(["setUserInfo", "setRole"]),
    targetPage() {
      const callbackName = "wxLoginCallback";
      const redirectUrl = window.location.origin + "/wxlogin";
      this.toAuthorizationPage(callbackName, redirectUrl);
    },
    fnLogin() {
      if (!this.agree) {
        this.$root.$toast.fail("请查看并同意用户协议");
        return;
      }
      if (!this.agree2) {
        this.$root.$toast.fail("请查看并同意隐私协议");
        return;
      }
      const res = this.gettel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      this.loading = true;
      const p = {
        code: this.phone,
        password: this.pwd
        // userType: this.$store.getters.getUserType
      };
      if (this.actionsValue == "中国香港+852") {
        p.code = "852" + this.phone;
      }
      if (this.actionsValue == "中国澳门+853") {
        p.code = "853" + this.phone;
      }
      login(p).then((res) => {
        this.loading = false;
        if (res.success) {
          this.setUserInfo(res.data);
          const userType = parseInt(res.data.userType);
          switch (userType) {
            case 1:
              this.setRole(0);
              break;
            case 3:
              this.setRole(1);
              break;
            case 4:
              this.setRole(2);
              break;
            case 5:
              this.setRole(3);
              break;
            default:
              this.setRole(-1);
          }
          if (userType == 5 && res.data.updPassType == 0)
            this.$root.$toast.success({
              message: "登录成功，首次登录后需要修改密码",
              duration: 2500,
              onClose: () => {
                this.$router.push("/pwdretrieve");
              }
            });
          else {
            console.log(localStorage.getItem("page"));
            this.$root.$toast.success({
              message: "登录成功",
              duration: 1500,
              onClose: () => {
                if (localStorage.getItem("page") == null) {
                  this.$router.push("/");
                } else {
                  this.$router.push(localStorage.getItem("page"));
                  localStorage.removeItem("page");
                }
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-player {
  height: 100%;
  width: 100%;

  .login-handle {
    margin: 0 auto;
    margin-top: 12px;
    width: 335px;

    .input {
      width: 335px;
      border-radius: 5px;
      overflow: hidden;
      margin: 0 auto;
      min-height: 96px;

      .pwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }

      .phone-ico {
        background: url("../../assets/images/login/phone.png") no-repeat;
      }

      .inp-ico {
        width: 55px;
        height: 55px;
        background-size: 20px 20px;
        background-position: center center;
      }
    }

    .other {
      overflow: hidden;
      min-height: 255px;

      .agreement {
        width: 335px;
        margin: 0 auto;
        margin-top: 24px;
        height: 20px;
        align-items: center;
        display: flex;
        font-size: 12px;
        color: #333333;
        justify-content: center;

        span {
          margin-left: 5px;
        }
      }

      p {
        font-size: 12px;
        text-align: center;
        color: #999999;
        margin-top: 12px;
      }

      .login-btn {
        margin-top: 20px;
      }

      .user-handle {
        display: flex;
        justify-content: space-around;
        color: #666;
        height: 20px;
        line-height: 20px;
        width: 300px;
        margin: 0 auto;
        margin-top: 10px;
        font-size: 14px;
        color: #245c9b;

        div {
          &:first-child {
            position: relative;
            // &::after {
            //   content: "";
            //   display: block;
            //   position: absolute;
            //   width: 2px;
            //   background-color: #245c9b;
            //   height: 16px;
            //   top: 1px;
            //   right: -9px;
            // }
          }

          &:last-child {
            // margin-left: 8px;
          }
        }
      }

      .wx-login {
        margin-bottom: 60px;

        p {
          font-size: 14px;
          color: #999;
          margin-top: 20px;
          line-height: 20px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          &::before {
            content: "";
            height: 1px;
            background-color: #dddddd;
            width: 42px;
            margin-right: 15px;
          }

          &::after {
            content: "";
            height: 1px;
            background-color: #dddddd;
            width: 42px;
            margin-left: 15px;
          }
        }

        .wx-logo {
          height: 28px;
          width: 34px;
          // border: 1px solid #2dd07b;
          // border-radius: 50%;
          background-image: url("../../assets/images/login/wx-ico.png");
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 34px 28px;
          margin: 0 auto;
          margin-top: 14px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";

.inputPhone {
  .van-field__body {
    display: flex;
    flex-direction: row-reverse;
  }

  .van-field__button {
    padding-left: 0px !important;
    padding-right: 5px !important;
  }

  .arrowBox {
    width: 96px;
    min-width: 100px;
  }

  .arrow {
    width: 8px !important;
    height: 8px !important;
    margin-left: 4px;
  }
}
</style>
